import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María G.',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'Carlos R.',
  city: 'CDMX',
  country: 'México'
}, {
  name: 'Ana L.',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Sofía N.',
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  name: 'Juan M.',
  city: 'Lima',
  country: 'Perú'
}, {
  name: 'Laura V.',
  city: 'Quito',
  country: 'Ecuador'
}, {
  name: 'Patricia S.',
  city: 'La Paz',
  country: 'Bolivia'
}, {
  name: 'Daniela P.',
  city: 'Santiago',
  country: 'Chile'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 4000);
    // Loop
    const interval = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-183">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 bg-white rounded-lg shadow-xl p-4 max-w-xs z-40 border-l-4 border-green-500 flex items-start gap-3" data-id="element-184">
          <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-185">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-186" />
          </div>
          <div data-id="element-187">
            <p className="text-sm font-bold text-gray-900" data-id="element-188">
              {currentPurchase.name} de {currentPurchase.city},{' '}
              {currentPurchase.country}
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-189">
              acaba de comprar el{' '}
              <span className="font-semibold text-blue-600" data-id="element-190">
                MegaPack Informática
              </span>
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-191">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}